import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';

import './nikke-element.scss';

interface IProps {
  element: string;
}

export const NikkeElement: React.FC<IProps> = ({ element }) => {
  const popoverElement = (
    <Popover id="popover-element">
      <Popover.Header as="h3">{element}</Popover.Header>
      <Popover.Body>
        {element === 'Electric' && (
          <>
            Inject CODE: Z.E.U.S to all water-type enemies, dealing 10%
            additional damage.
          </>
        )}
        {element === 'Fire' && (
          <>
            Inject CODE: H.S.T.A. to all wind-type enemies, dealing 10%
            additional damage.
          </>
        )}
        {element === 'Iron' && (
          <>
            Inject CODE: D.M.T.R. to all electric-type enemies, dealing 10%
            additional damage.
          </>
        )}
        {element === 'Water' && (
          <>
            Inject CODE: P.S.I.D to all fire-type enemies, dealing 10%
            additional damage.
          </>
        )}
        {element === 'Wind' && (
          <>
            Inject CODE: A.N.M.I to all iron-type enemies, dealing 10%
            additional damage.
          </>
        )}
        {element === 'Unknown' && (
          <>Element for this character isn't known yet.</>
        )}
      </Popover.Body>
    </Popover>
  );
  return (
    <OverlayTrigger
      trigger="click"
      rootClose
      placement="auto-start"
      overlay={popoverElement}
    >
      <div className={`nikke-element ${element}`}>
        {element === 'Electric' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/element_electric.png"
              alt={element}
            />
            <span>{element}</span>
          </>
        )}
        {element === 'Fire' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/element_fire.png"
              alt={element}
            />
            <span>{element}</span>
          </>
        )}
        {element === 'Iron' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/element_iron.png"
              alt={element}
            />
            <span>{element}</span>
          </>
        )}
        {element === 'Water' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/element_water.png"
              alt={element}
            />
            <span>{element}</span>
          </>
        )}
        {element === 'Wind' && (
          <>
            <StaticImage
              src="../../../../images/nikke/icons/element_wind.png"
              alt={element}
            />
            <span>{element}</span>
          </>
        )}
        {element === 'Unknown' && (
          <>
            <span>{element}</span>
          </>
        )}
      </div>
    </OverlayTrigger>
  );
};
